// Roster Attendance Constants
export const FETCH_ROSTER_ATTENDANCE_REQUEST = "FETCH_ROSTER_ATTENDANCE_REQUEST";
export const FETCH_ROSTER_ATTENDANCE_SUCCESS = "FETCH_ROSTER_ATTENDANCE_SUCCESS";
export const FETCH_ROSTER_ATTENDANCE_FAILURE = "FETCH_ROSTER_ATTENDANCE_FAILURE";

export const FETCH_ROSTER_ABSENT_DETAILS_REQUEST = "FETCH_ROSTER_ABSENT_DETAILS_REQUEST";
export const FETCH_ROSTER_ABSENT_DETAILS_SUCCESS = "FETCH_ROSTER_ABSENT_DETAILS_SUCCESS";
export const FETCH_ROSTER_ABSENT_DETAILS_FAILURE = "FETCH_ROSTER_ABSENT_DETAILS_FAILURE";

// Absent Summary Constants
export const FETCH_ABSENT_SUMMARY_REQUEST = "FETCH_ABSENT_SUMMARY_REQUEST";
export const FETCH_ABSENT_SUMMARY_SUCCESS = "FETCH_ABSENT_SUMMARY_SUCCESS";
export const FETCH_ABSENT_SUMMARY_FAILURE = "FETCH_ABSENT_SUMMARY_FAILURE";

// Roster Type Constants
export const ROSTER_TYPE = {
  ROSTER: "A",
  COMMON: "N"
};

// Attendance Thresholds
export const ATTENDANCE_THRESHOLDS = {
  HIGH: 70,
  MEDIUM: 50,
  LOW: 0
};





// // Roster Attendance Constants
// export const FETCH_ROSTER_ATTENDANCE_REQUEST = "FETCH_ROSTER_ATTENDANCE_REQUEST";
// export const FETCH_ROSTER_ATTENDANCE_SUCCESS = "FETCH_ROSTER_ATTENDANCE_SUCCESS";
// export const FETCH_ROSTER_ATTENDANCE_FAILURE = "FETCH_ROSTER_ATTENDANCE_FAILURE";

// // Roster Absent Details Constants
// export const FETCH_ROSTER_ABSENT_DETAILS_REQUEST = "FETCH_ROSTER_ABSENT_DETAILS_REQUEST";
// export const FETCH_ROSTER_ABSENT_DETAILS_SUCCESS = "FETCH_ROSTER_ABSENT_DETAILS_SUCCESS";
// export const FETCH_ROSTER_ABSENT_DETAILS_FAILURE = "FETCH_ROSTER_ABSENT_DETAILS_FAILURE";

// // Roster Types
// export const ROSTER_TYPE = {
//   ROSTER: "A",    // Roster location
//   COMMON: "N"     // Common location (non-roster)
// };

// // Optional: Add more constants as needed
// export const ATTENDANCE_THRESHOLDS = {
//   HIGH: 70,
//   MEDIUM: 50,
//   LOW: 0
// };